/* spj boutique — theme.js
 * Shopify AJAX cart + interactive UI.
 * Re-binds on shopify:section:load so the theme editor stays interactive.
 */

const $  = (s, r=document) => r.querySelector(s);
const $$ = (s, r=document) => [...r.querySelectorAll(s)];
const isEditor = !!(window.Shopify && window.Shopify.designMode);

const moneyFormat = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
function formatMoney(cents){
  const n = (cents/100);
  return moneyFormat
    .replace(/\{\{\s*amount\s*\}\}/, n.toFixed(2))
    .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(n).toString())
    .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.toFixed(2).replace('.', ','))
    .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(n).toString());
}

/* ---------- nav scroll state ---------- */
function initNav(){
  const nav = $('[data-nav]');
  if (!nav || nav.__navBound) return;
  nav.__navBound = true;
  const onScroll = () => nav.classList.toggle('scrolled', window.scrollY > 60);
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

/* ---------- side menu / cart drawer ---------- */
let overlayEl = null;
let sideMenuEl = null;
let cartEl = null;

function openSideMenu(){ sideMenuEl?.classList.add('open'); overlayEl?.classList.add('show'); sideMenuEl?.setAttribute('aria-hidden','false'); }
function closeSideMenu(){ sideMenuEl?.classList.remove('open'); overlayEl?.classList.remove('show'); sideMenuEl?.setAttribute('aria-hidden','true'); }
function openCart(){ cartEl?.classList.add('open'); overlayEl?.classList.add('show'); cartEl?.setAttribute('aria-hidden','false'); }
function closeCart(){ cartEl?.classList.remove('open'); overlayEl?.classList.remove('show'); cartEl?.setAttribute('aria-hidden','true'); }

function initDrawers(scope = document){
  overlayEl = overlayEl || $('[data-overlay]');
  sideMenuEl = sideMenuEl || $('[data-side-menu]');
  cartEl = cartEl || $('[data-cart]');

  scope.querySelectorAll('[data-menu-open]').forEach(b => {
    if (b.__bound) return; b.__bound = true;
    b.addEventListener('click', openSideMenu);
  });
  scope.querySelectorAll('[data-menu-close]').forEach(b => {
    if (b.__bound) return; b.__bound = true;
    b.addEventListener('click', closeSideMenu);
  });
  scope.querySelectorAll('[data-cart-open]').forEach(b => {
    if (b.__bound) return; b.__bound = true;
    b.addEventListener('click', openCart);
  });
  scope.querySelectorAll('[data-cart-close]').forEach(b => {
    if (b.__bound) return; b.__bound = true;
    b.addEventListener('click', closeCart);
  });

  if (overlayEl && !overlayEl.__bound){
    overlayEl.__bound = true;
    overlayEl.addEventListener('click', () => { closeSideMenu(); closeCart(); });
  }
  if (!document.__escBound){
    document.__escBound = true;
    document.addEventListener('keydown', e => { if (e.key === 'Escape'){ closeSideMenu(); closeCart(); } });
  }
}

/* ---------- toast ---------- */
function showToast(msg){
  const toast = $('#toast');
  if (!toast) return;
  toast.textContent = msg;
  toast.classList.add('show');
  clearTimeout(showToast._t);
  showToast._t = setTimeout(() => toast.classList.remove('show'), 2200);
}

/* ---------- cart state + render ---------- */
async function fetchCart(){
  const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
  return res.json();
}

function renderCart(state){
  const cartItemsEl = $('[data-cart-items]');
  const cartTotalEl = $('[data-cart-total]');
  const cartCountEl = $('[data-cart-count]');
  if (!cartItemsEl) return;

  if (state.item_count === 0){
    cartItemsEl.innerHTML = `<p class="cart-empty">your bag is quiet.</p>`;
  } else {
    cartItemsEl.innerHTML = state.items.map((item, i) => {
      const isDiscounted = item.original_line_price !== item.final_line_price;
      const priceHtml = isDiscounted
        ? '<s class="pr-was">' + formatMoney(item.original_line_price) + '</s><span class="pr-now">' + formatMoney(item.final_line_price) + '</span>'
        : formatMoney(item.final_line_price);
      return `
      <div class="cart-line" data-line-key="${item.key}" data-line-index="${i+1}">
        <div class="ph">${item.image ? `<img src="${item.image}" alt="${item.product_title}">` : ''}</div>
        <div>
          <div class="nm">${item.product_title}</div>
          <div class="sc">${(item.variant_title || '').toLowerCase()}</div>
          <div class="qty">
            <button data-line-dec aria-label="decrease">−</button>
            <span data-line-qty>${item.quantity}</span>
            <button data-line-inc aria-label="increase">+</button>
          </div>
        </div>
        <div class="pr">${priceHtml}</div>
      </div>
    `;
    }).join('');
  }

  if (cartTotalEl) cartTotalEl.textContent = formatMoney(state.total_price);
  if (cartCountEl){
    cartCountEl.textContent = state.item_count;
    cartCountEl.classList.remove('bump');
    void cartCountEl.offsetWidth;
    cartCountEl.classList.add('bump');
  }
  updateCartRewardsPoints(state.total_price);
}

async function refreshCart(){
  try {
    const state = await fetchCart();
    renderCart(state);
    return state;
  } catch (_){ /* not on a real Shopify domain */ }
}

/* ---------- add to cart ---------- */
function bindAddForms(scope = document){
  scope.querySelectorAll('[data-add-form]').forEach(form => {
    if (form.__bound) return; form.__bound = true;
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = form.querySelector('[data-add]');
      const fd = new FormData(form);
      btn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!res.ok){ throw new Error('add failed'); }
        const item = await res.json();
        btn.classList.add('added');
        btn.textContent = 'added ✓';
        showToast(`${item.product_title} added to bag`);
        await refreshCart();
        setTimeout(openCart, 250);
        setTimeout(() => { btn.classList.remove('added'); btn.textContent = 'add to bag'; btn.disabled = false; }, 1500);
      } catch (err){
        btn.disabled = false;
        showToast('something went wrong');
      }
    });
  });
}

/* ---------- qty controls in drawer ---------- */
function bindCartLines(){
  const cartItemsEl = $('[data-cart-items]');
  if (!cartItemsEl || cartItemsEl.__bound) return;
  cartItemsEl.__bound = true;
  cartItemsEl.addEventListener('click', async e => {
    const line = e.target.closest('.cart-line');
    if (!line) return;
    const idx = Number(line.dataset.lineIndex);
    const qtyEl = line.querySelector('[data-line-qty]');
    let qty = Number(qtyEl?.textContent || 0);
    if (e.target.matches('[data-line-inc]')) qty++;
    else if (e.target.matches('[data-line-dec]')) qty = Math.max(0, qty - 1);
    else return;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ line: idx, quantity: qty })
      });
      if (res.ok){
        const state = await res.json();
        renderCart(state);
      }
    } catch (_){ /* no-op */ }
  });
}

/* ---------- accordion ---------- */
function bindAccordion(scope = document){
  scope.querySelectorAll('[data-acc]').forEach(row => {
    if (row.__bound) return; row.__bound = true;
    const head = row.querySelector('.acc-head');
    head?.addEventListener('click', () => {
      const open = row.classList.toggle('open');
      head.setAttribute('aria-expanded', String(open));
    });
  });
}

/* ---------- newsletter ---------- */
function bindNewsletter(scope = document){
  const form = scope.querySelector('#nlForm');
  if (!form || form.__bound) return;
  form.__bound = true;
  form.addEventListener('submit', e => {
    const email = form.querySelector('input[type=email]')?.value.trim() || '';
    if (!/^\S+@\S+\.\S+$/.test(email)){
      e.preventDefault();
      showToast('please enter a valid email');
      return;
    }
    const success = form.querySelector('[data-nl-success]');
    if (success){ success.classList.add('show'); }
  });
}

/* ---------- reveal-on-scroll (skipped in theme editor) ---------- */
let revealIO = null;
function getRevealObserver(){
  if (revealIO) return revealIO;
  revealIO = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting){
        e.target.classList.add('in');
        revealIO.unobserve(e.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
  return revealIO;
}

function initReveal(scope = document){
  const els = scope.querySelectorAll('.reveal, .reveal-l, .reveal-r');
  if (isEditor){
    // In the theme editor, skip the animation so content is always visible.
    els.forEach(el => el.classList.add('in'));
    return;
  }
  const io = getRevealObserver();
  els.forEach(el => {
    if (el.__observed) return;
    el.__observed = true;
    io.observe(el);
  });
}

/* ---------- parallax ---------- */
function initParallax(scope = document){
  const par = scope.querySelector('[data-parallax] img');
  if (!par || par.__bound) return;
  par.__bound = true;
  let raf = null;
  const update = () => {
    raf = null;
    const r = par.getBoundingClientRect();
    const v = window.innerHeight;
    const p = (r.top - v) / (v + r.height);
    const t = Math.max(-30, Math.min(30, -p * 60));
    par.style.transform = `translate3d(0,${t}px,0) scale(1.08)`;
  };
  window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
  update();
}

/* ---------- anchors close menu ---------- */
function bindAnchors(scope = document){
  scope.querySelectorAll('a[href^="#"]').forEach(a => {
    if (a.__bound) return; a.__bound = true;
    a.addEventListener('click', () => setTimeout(closeSideMenu, 100));
  });
}

/* ---------- wishlist toggle ---------- */
function bindWishlist(scope = document){
  let saved = [];
  try { saved = JSON.parse(localStorage.getItem('spj_wishlist') || '[]'); } catch(_){}
  scope.querySelectorAll('[data-wishlist]').forEach(btn => {
    if (btn.__bound) return; btn.__bound = true;
    const card = btn.closest('[data-product]');
    const handle = card?.dataset.product;
    if (handle && saved.includes(handle)) btn.classList.add('active');
    btn.addEventListener('click', (e) => {
      e.preventDefault(); e.stopPropagation();
      if (!handle) { btn.classList.toggle('active'); return; }
      const idx = saved.indexOf(handle);
      if (idx >= 0){ saved.splice(idx, 1); btn.classList.remove('active'); showToast('removed from wishlist'); }
      else { saved.push(handle); btn.classList.add('active'); showToast('added to wishlist'); }
      try { localStorage.setItem('spj_wishlist', JSON.stringify(saved)); } catch(_){}
    });
  });
}

/* ---------- Smile.io rewards integration ---------- */
function openSmilePanel(){
  // Smile.io exposes window.SmileUI when their app is installed
  if (window.SmileUI && typeof window.SmileUI.openPanel === 'function'){
    window.SmileUI.openPanel();
    return true;
  }
  // Fallback: click their launcher button if it exists
  const launcher = document.querySelector('#smile-launcher-frame-container, [aria-label*="Rewards"], .smile-launcher-frame-container');
  if (launcher){ launcher.click(); return true; }
  // If neither — show toast guiding the merchant
  showToast('Install Smile.io to activate rewards');
  return false;
}

function bindSmileLaunchers(scope = document){
  scope.querySelectorAll('[data-smile-launch]').forEach(el => {
    if (el.__smileBound) return; el.__smileBound = true;
    el.addEventListener('click', (e) => {
      e.preventDefault();
      openSmilePanel();
    });
  });
}

function updateCartRewardsPoints(totalCents){
  document.querySelectorAll('[data-cart-rewards]').forEach(box => {
    const rate = parseFloat(box.dataset.rewardsRate || '1');
    const dollars = totalCents / 100;
    const pts = Math.floor(dollars * rate);
    const out = box.querySelector('[data-cart-rewards-points]');
    if (out) out.textContent = pts;
  });
  updateCartMilestone(totalCents);
}

function updateCartMilestone(totalCents){
  document.querySelectorAll('[data-cart-milestone]').forEach(box => {
    const goalCents = parseInt(box.dataset.milestoneCents || '0', 10);
    const bonusPts  = parseInt(box.dataset.milestonePoints || '0', 10);
    if (goalCents <= 0) return;

    const pct = Math.min(100, Math.round((totalCents / goalCents) * 100));
    const fill = box.querySelector('[data-cart-milestone-fill]');
    if (fill) fill.style.width = pct + '%';

    const label = box.querySelector('.cart-milestone-label');
    if (!label) return;

    if (totalCents >= goalCents){
      label.innerHTML = `<span data-cart-milestone-hit><strong>+${bonusPts} bonus points unlocked! 🎉</strong></span>`;
    } else {
      const remaining = goalCents - totalCents;
      label.innerHTML = `<span>Spend <strong data-cart-milestone-remaining>${formatMoney(remaining)}</strong> more to unlock <strong>+${bonusPts}</strong> bonus points</span>`;
    }
  });
}

/* ---------- recently viewed (tracker + renderer) ---------- */
const RV_KEY = 'spj-recently-viewed';
const RV_MAX = 12;

function trackRecentlyViewed(handle){
  if (!handle) return;
  try {
    let list = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
    list = list.filter(h => h !== handle);
    list.unshift(handle);
    if (list.length > RV_MAX) list = list.slice(0, RV_MAX);
    localStorage.setItem(RV_KEY, JSON.stringify(list));
  } catch (e){ /* localStorage unavailable */ }
}

async function renderRecentlyViewed(scope = document){
  const box = scope.querySelector('[data-recently-viewed]');
  if (!box || box.__rvBound) return;
  box.__rvBound = true;

  const currentHandle = box.dataset.currentHandle;
  const limit = parseInt(box.dataset.limit || '8', 10);
  const grid = box.querySelector('[data-recently-grid]');
  if (!grid) return;

  let handles = [];
  try { handles = JSON.parse(localStorage.getItem(RV_KEY) || '[]'); } catch (e) {}
  handles = handles.filter(h => h !== currentHandle).slice(0, limit);

  if (handles.length === 0){ box.style.display = 'none'; return; }

  try {
    const results = await Promise.all(handles.map(h =>
      fetch(`/products/${h}.js`).then(r => r.ok ? r.json() : null).catch(() => null)
    ));
    const products = results.filter(Boolean);
    if (products.length === 0){ box.style.display = 'none'; return; }

    grid.innerHTML = products.map(p => {
      const variant = p.variants[0];
      const sizeOpt = p.options.findIndex(o => /size/i.test(o));
      const sizeBtns = sizeOpt >= 0 ? p.variants.map(v =>
        `<button class="qs-size" data-size="${v.options[sizeOpt]}" data-variant-id="${v.id}" type="button" ${v.available ? '' : 'disabled'}>${v.options[sizeOpt]}</button>`
      ).join('') : p.variants.map(v =>
        `<button class="qs-size" data-size="${v.title}" data-variant-id="${v.id}" type="button" ${v.available ? '' : 'disabled'}>${v.title}</button>`
      ).join('');

      const price = formatMoney(p.price);
      const compare = p.compare_at_price && p.compare_at_price > p.price
        ? `<span class="compare">${formatMoney(p.compare_at_price)}</span>` : '';
      const sale = p.compare_at_price && p.compare_at_price > p.price ? '<span class="qs-badge">Sale</span>' : '';
      const front = p.featured_image ? `<img class="qs-front" src="${p.featured_image}" alt="${p.title}" loading="lazy">` : '';
      const back = p.images.length > 1 ? `<img class="qs-back" src="${p.images[1]}" alt="${p.title}" loading="lazy">` : '';

      return `
        <article class="qs-card" data-quick-card data-handle="${p.handle}">
          ${sale}
          <button class="qs-wishlist" data-wish="${p.handle}" aria-label="add to wishlist" type="button">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 20s-7-4.35-9.5-9.18C.8 7.5 3 4 6.5 4c2 0 3.5 1.2 4.5 2.5C12 5.2 13.5 4 15.5 4 19 4 21.2 7.5 19.5 10.82 17 15.65 12 20 12 20Z"/></svg>
          </button>
          <a href="/products/${p.handle}" class="qs-media">${front}${back}</a>
          ${p.variants.length > 0 ? `
            <button class="qs-quickadd" data-quickadd-trigger type="button" aria-label="quick add ${p.title}"><span aria-hidden="true">+</span> Quick Add</button>
            <div class="qs-sizes" data-quickadd-sizes role="group" aria-label="select size">${sizeBtns}</div>
          ` : ''}
          <div class="qs-body">
            <h3><a href="/products/${p.handle}">${p.title}</a></h3>
            <div><span class="price">${price}</span>${compare}</div>
          </div>
        </article>`;
    }).join('');

    // re-bind quick-add to freshly rendered cards
    bindQuickAdd(grid);
  } catch (e){
    box.style.display = 'none';
  }
}

/* ---------- product page (PDP) ---------- */
function bindPDP(scope = document){
  const pdp = scope.querySelector('[data-pdp]');
  if (!pdp || pdp.__pdpBound) return;
  pdp.__pdpBound = true;

  // track in recently-viewed (excludes the current product on render)
  trackRecentlyViewed(pdp.dataset.productHandle);

  // gallery thumbnail + arrow swap
  const stage  = pdp.querySelector('[data-gallery-stage]');
  const slides = stage ? [...stage.querySelectorAll('[data-gallery-slide]')] : [];
  const thumbs = [...pdp.querySelectorAll('[data-gallery-thumb]')];
  let gIdx = 0;
  const goImg = (n) => {
    if (slides.length === 0) return;
    gIdx = (n + slides.length) % slides.length;
    slides.forEach((s,i) => s.classList.toggle('is-active', i === gIdx));
    thumbs.forEach((t,i) => { t.classList.toggle('is-active', i === gIdx); t.setAttribute('aria-selected', i === gIdx ? 'true' : 'false'); });
    const active = slides[gIdx];
    if (active){ const id = active.dataset.imageId; pdp.dataset.activeImage = id || ''; }
  };
  thumbs.forEach((t,i) => t.addEventListener('click', () => goImg(i)));
  pdp.querySelector('[data-gallery-prev]')?.addEventListener('click', () => goImg(gIdx - 1));
  pdp.querySelector('[data-gallery-next]')?.addEventListener('click', () => goImg(gIdx + 1));

  // variant picker
  const dataEl = pdp.querySelector('[data-product-json]');
  let productData = null;
  try { productData = dataEl ? JSON.parse(dataEl.textContent) : null; } catch(e){ console.error('pdp json parse', e); }
  if (!productData) return;

  const form = pdp.querySelector('[data-add-form]');
  const variantInput = pdp.querySelector('[data-variant-id-input]');
  const priceEl = pdp.querySelector('[data-price]');
  const compareEl = pdp.querySelector('[data-compare]');
  const atcBtn = pdp.querySelector('[data-add]');
  const atcPrice = pdp.querySelector('[data-atc-price]');

  const optionInputs = [...pdp.querySelectorAll('[data-option-value]')];

  const formatPrice = (cents) => formatMoney(cents);

  const findMatchingVariant = () => {
    const optionFieldsets = [...pdp.querySelectorAll('.pdp-opt')];
    // Product has only the default variant — no option pickers rendered
    if (optionFieldsets.length === 0) return productData.variants[0] || null;
    const selectedByPosition = [];
    optionFieldsets.forEach(fs => {
      const idx = parseInt(fs.dataset.optionIndex, 10);
      const checked = fs.querySelector('[data-option-value]:checked');
      selectedByPosition[idx] = checked ? checked.value : null;
    });
    return productData.variants.find(v => v.options.every((opt, i) => opt === selectedByPosition[i]));
  };

  const refreshAvailability = () => {
    // For each option, disable values that have no available variant when combined with currently selected others
    const fieldsets = [...pdp.querySelectorAll('.pdp-opt')];
    const selectedByPosition = fieldsets.map(fs => {
      const checked = fs.querySelector('[data-option-value]:checked');
      return checked ? checked.value : null;
    });

    fieldsets.forEach((fs, optIdx) => {
      const inputs = [...fs.querySelectorAll('[data-option-value]')];
      inputs.forEach(inp => {
        const trial = selectedByPosition.slice();
        trial[optIdx] = inp.value;
        const hasAvail = productData.variants.some(v => v.available && v.options.every((opt, i) => trial[i] == null || opt === trial[i]));
        inp.disabled = !hasAvail;
      });
    });
  };

  const updateForVariant = (variant) => {
    if (!variant){
      atcBtn.disabled = true;
      atcBtn.textContent = 'Unavailable';
      return;
    }
    variantInput.value = variant.id;

    // price
    if (priceEl){
      priceEl.textContent = formatPrice(variant.price);
      priceEl.classList.toggle('is-sale', variant.compare_at_price && variant.compare_at_price > variant.price);
    }
    if (compareEl){
      if (variant.compare_at_price && variant.compare_at_price > variant.price){
        compareEl.textContent = formatPrice(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (atcPrice) atcPrice.textContent = formatPrice(variant.price);

    // rewards earn points
    const rewardsEl = pdp.querySelector('[data-rewards-earn] [data-rewards-points]');
    if (rewardsEl){
      const rate = parseFloat(document.documentElement.dataset.rewardsRate || '1');
      const pts = Math.floor((variant.price / 100) * rate);
      rewardsEl.textContent = pts;
    }

    // ATC state
    if (atcBtn){
      if (variant.available){
        atcBtn.disabled = false;
        atcBtn.innerHTML = `Add to Bag — <span data-atc-price>${formatPrice(variant.price)}</span>`;
      } else {
        atcBtn.disabled = true;
        atcBtn.textContent = 'Sold Out';
      }
    }

    // Update selected-value label
    pdp.querySelectorAll('.pdp-opt').forEach((fs, idx) => {
      const out = fs.querySelector('[data-opt-selected]');
      if (out){
        const checked = fs.querySelector('[data-option-value]:checked');
        out.textContent = checked ? checked.value : '';
      }
    });

    // Swap gallery image if variant has its own
    if (variant.featured_image && variant.featured_image.id){
      const idx = slides.findIndex(s => s.dataset.imageId == variant.featured_image.id);
      if (idx >= 0) goImg(idx);
    }

    // Update URL with variant id (no reload)
    if (history.replaceState){
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }
  };

  optionInputs.forEach(inp => {
    inp.addEventListener('change', () => {
      const v = findMatchingVariant();
      updateForVariant(v);
      refreshAvailability();
    });
  });

  // initial pass
  refreshAvailability();
  updateForVariant(findMatchingVariant());

  // qty stepper
  const qty = pdp.querySelector('[data-qty]');
  if (qty){
    const input = qty.querySelector('[data-qty-input]');
    qty.querySelector('[data-qty-dec]')?.addEventListener('click', () => { input.value = Math.max(1, parseInt(input.value, 10) - 1); });
    qty.querySelector('[data-qty-inc]')?.addEventListener('click', () => { input.value = parseInt(input.value, 10) + 1; });
  }

  // AJAX add to cart
  form?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const formData = new FormData(form);
    atcBtn.disabled = true;
    const originalLabel = atcBtn.innerHTML;
    atcBtn.textContent = 'Adding…';
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } });
      if (!res.ok) throw new Error('add failed');
      const cart = await (await fetch('/cart.js')).json();
      const cc = document.querySelector('[data-cart-count]');
      if (cc){ cc.textContent = cart.item_count; cc.classList.add('bump'); setTimeout(()=>cc.classList.remove('bump'), 350); }
      showToast('Added to bag');
      const openCart = document.querySelector('[data-cart-open]');
      openCart && openCart.click();
      atcBtn.disabled = false;
      atcBtn.innerHTML = originalLabel;
    } catch (err){
      atcBtn.disabled = false;
      atcBtn.innerHTML = originalLabel;
      showToast('Could not add — try again');
    }
  });

  // wishlist
  const wishBtn = pdp.querySelector('[data-pdp-wish]');
  if (wishBtn){
    const handle = wishBtn.dataset.wish;
    const key = 'spj-wishlist';
    const list = JSON.parse(localStorage.getItem(key) || '[]');
    if (list.includes(handle)) wishBtn.classList.add('active');
    wishBtn.addEventListener('click', () => {
      const cur = JSON.parse(localStorage.getItem(key) || '[]');
      const idx = cur.indexOf(handle);
      if (idx >= 0){ cur.splice(idx, 1); wishBtn.classList.remove('active'); showToast('Removed from wishlist'); }
      else { cur.push(handle); wishBtn.classList.add('active'); showToast('Saved to wishlist'); }
      localStorage.setItem(key, JSON.stringify(cur));
    });
  }
}

/* ---------- wishlist (heart buttons) ---------- */
const WL_KEY = 'spj-wishlist';
function getWishlist(){ try { return JSON.parse(localStorage.getItem(WL_KEY) || '[]'); } catch (e){ return []; } }
function setWishlist(arr){ try { localStorage.setItem(WL_KEY, JSON.stringify(arr)); } catch (e){} }

function bindWishlistButtons(scope = document){
  const list = getWishlist();
  scope.querySelectorAll('[data-wish]').forEach(btn => {
    const handle = btn.dataset.wish;
    if (!handle) return;
    if (list.includes(handle)) btn.classList.add('active');

    if (btn.__wlBound) return; btn.__wlBound = true;
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      let l = getWishlist();
      if (l.includes(handle)){
        l = l.filter(h => h !== handle);
        btn.classList.remove('active');
        showToast('Removed from favorites');
      } else {
        l.unshift(handle);
        btn.classList.add('active');
        showToast('Saved to favorites');
      }
      setWishlist(l);
      // update the heart count in nav if present
      const counter = document.querySelector('[data-wishlist-count]');
      if (counter){ counter.textContent = l.length; counter.style.display = l.length > 0 ? '' : 'none'; }
      // mirror on all hearts for same handle on the page
      document.querySelectorAll(`[data-wish="${handle}"]`).forEach(b => b.classList.toggle('active', l.includes(handle)));
    });
  });
  // sync nav badge on load
  const counter = document.querySelector('[data-wishlist-count]');
  if (counter){ counter.textContent = list.length; counter.style.display = list.length > 0 ? '' : 'none'; }
}

async function renderFavorites(scope = document){
  const box = scope.querySelector('[data-favorites]');
  if (!box || box.__favBound) return;
  box.__favBound = true;
  const grid = box.querySelector('[data-favorites-grid]');
  const empty = box.querySelector('[data-favorites-empty]');
  if (!grid) return;

  const handles = getWishlist();
  if (handles.length === 0){
    if (empty) empty.style.display = '';
    return;
  }
  if (empty) empty.style.display = 'none';

  try {
    const results = await Promise.all(handles.map(h =>
      fetch(`/products/${h}.js`).then(r => r.ok ? r.json() : null).catch(() => null)
    ));
    const products = results.filter(Boolean);
    if (products.length === 0){ if (empty) empty.style.display = ''; return; }

    grid.innerHTML = products.map(p => {
      const sizeOpt = p.options.findIndex(o => /size/i.test(o));
      const sizeBtns = sizeOpt >= 0 ? p.variants.map(v =>
        `<button class="qs-size" data-size="${v.options[sizeOpt]}" data-variant-id="${v.id}" type="button" ${v.available ? '' : 'disabled'}>${v.options[sizeOpt]}</button>`
      ).join('') : p.variants.map(v =>
        `<button class="qs-size" data-size="${v.title}" data-variant-id="${v.id}" type="button" ${v.available ? '' : 'disabled'}>${v.title}</button>`
      ).join('');

      const price = formatMoney(p.price);
      const compare = p.compare_at_price && p.compare_at_price > p.price
        ? `<span class="compare">${formatMoney(p.compare_at_price)}</span>` : '';
      const sale = p.compare_at_price && p.compare_at_price > p.price ? '<span class="qs-badge">Sale</span>' : '';
      const front = p.featured_image ? `<img class="qs-front" src="${p.featured_image}" alt="${p.title}" loading="lazy">` : '';
      const back = p.images.length > 1 ? `<img class="qs-back" src="${p.images[1]}" alt="${p.title}" loading="lazy">` : '';

      return `
        <article class="qs-card" data-quick-card data-handle="${p.handle}">
          ${sale}
          <button class="qs-wishlist active" data-wish="${p.handle}" aria-label="remove from favorites" type="button">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 20s-7-4.35-9.5-9.18C.8 7.5 3 4 6.5 4c2 0 3.5 1.2 4.5 2.5C12 5.2 13.5 4 15.5 4 19 4 21.2 7.5 19.5 10.82 17 15.65 12 20 12 20Z"/></svg>
          </button>
          <a href="/products/${p.handle}" class="qs-media">${front}${back}</a>
          ${p.variants.length > 0 ? `
            <button class="qs-quickadd" data-quickadd-trigger type="button" aria-label="quick add ${p.title}"><span aria-hidden="true">+</span> Quick Add</button>
            <div class="qs-sizes" data-quickadd-sizes role="group" aria-label="select size">${sizeBtns}</div>
          ` : ''}
          <div class="qs-body">
            <h3><a href="/products/${p.handle}">${p.title}</a></h3>
            <div><span class="price">${price}</span>${compare}</div>
          </div>
        </article>`;
    }).join('');

    bindQuickAdd(grid);
    bindWishlistButtons(grid);
  } catch (e){
    if (empty) empty.style.display = '';
  }
}

/* ---------- collection page: filters + sort ---------- */
function bindCollectionFilters(scope = document){
  const shell = scope.querySelector('[data-coll-shell]');
  if (!shell || shell.__filtersBound) return;
  shell.__filtersBound = true;

  const grid = shell.querySelector('[data-coll-grid]');
  const cards = grid ? [...grid.querySelectorAll('[data-product]')] : [];
  const state = { colors:new Set(), sizes:new Set(), types:new Set(), priceMin:null, priceMax:null, inStock:false };

  const apply = () => {
    let visible = 0;
    cards.forEach(c => {
      const colors = c.dataset.colors || '';
      const sizes  = c.dataset.sizes  || '';
      const type   = c.dataset.type   || '';
      const price  = parseFloat(c.dataset.price) || 0;
      const available = c.dataset.available === 'true';
      let show = true;
      if (state.colors.size && ![...state.colors].some(v => (','+colors+',').includes(','+v+','))) show = false;
      if (state.sizes.size  && ![...state.sizes ].some(v => (','+sizes+',').includes(','+v+','))) show = false;
     if (state.types.size  && ![...state.types].some(v => type.split(',').map(t => t.trim()).includes(v))) show = false;
      if (state.priceMin !== null && price < state.priceMin) show = false;
      if (state.priceMax !== null && price > state.priceMax) show = false;
      if (state.inStock && !available) show = false;
      c.style.display = show ? '' : 'none';
      if (show) visible += 1;
    });
    const count = shell.parentElement.querySelector('.coll-count');
    if (count) count.textContent = `${visible} of ${cards.length} products`;
  };

  // in-stock toggle
  const inStockEl = shell.querySelector('[data-filter="in_stock"]');
  if (inStockEl){
    inStockEl.addEventListener('change', () => {
      state.inStock = inStockEl.checked;
      apply();
    });
  }

  // color swatches (toggle)
  shell.querySelectorAll('.color-sw').forEach(sw => {
    sw.addEventListener('click', () => {
      const v = sw.dataset.value;
      if (state.colors.has(v)){ state.colors.delete(v); sw.classList.remove('active'); }
      else { state.colors.add(v); sw.classList.add('active'); }
      apply();
    });
  });

  // size chips
  shell.querySelectorAll('.size-chip').forEach(ch => {
    ch.addEventListener('click', () => {
      const v = ch.dataset.value;
      if (state.sizes.has(v)){ state.sizes.delete(v); ch.classList.remove('active'); }
      else { state.sizes.add(v); ch.classList.add('active'); }
      apply();
    });
  });

  // type checkboxes
  shell.querySelectorAll('input[data-filter="type"]').forEach(cb => {
    cb.addEventListener('change', () => {
      const v = cb.dataset.value;
      if (cb.checked) state.types.add(v); else state.types.delete(v);
      apply();
    });
  });

  // price range
  const pMin = shell.querySelector('[data-filter="price_min"]');
  const pMax = shell.querySelector('[data-filter="price_max"]');
  [pMin, pMax].forEach(el => el && el.addEventListener('input', () => {
    state.priceMin = pMin && pMin.value !== '' ? parseFloat(pMin.value) : null;
    state.priceMax = pMax && pMax.value !== '' ? parseFloat(pMax.value) : null;
    apply();
  }));

  // clear
  const clear = shell.querySelector('[data-filter-clear]');
  clear && clear.addEventListener('click', () => {
    state.colors.clear(); state.sizes.clear(); state.types.clear();
    state.priceMin = null; state.priceMax = null; state.inStock = false;
    shell.querySelectorAll('.color-sw.active').forEach(e => e.classList.remove('active'));
    shell.querySelectorAll('.size-chip.active').forEach(e => e.classList.remove('active'));
    shell.querySelectorAll('input[data-filter="type"]:checked').forEach(e => e.checked = false);
    if (inStockEl) inStockEl.checked = false;
    if (pMin) pMin.value = ''; if (pMax) pMax.value = '';
    apply();
  });

  // mobile drawer toggle
 const toggle = scope.querySelector('[data-filter-toggle]');
const side = shell.querySelector('[data-filter-side]');

scope.querySelectorAll('[data-filter-toggle]').forEach(btn => {
  btn.addEventListener('click', () => side.classList.toggle('open'));
});

  // sort-by reload
  const sortSel = scope.querySelector('[data-sort-by]');
  if (sortSel){
    sortSel.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSel.value);
      window.location.href = url.toString();
    });
  }
}

/* ---------- quick add (homepage cards) ---------- */
function bindQuickAdd(scope = document){
  scope.querySelectorAll('[data-quick-card], [data-product]').forEach(card => {
    if (card.__qaBound) return; card.__qaBound = true;

    const trigger = card.querySelector('[data-quickadd-trigger]');
    const sizes   = card.querySelector('[data-quickadd-sizes]');
    if (!trigger || !sizes) return;

    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const sizeButtons = [...sizes.querySelectorAll('.qs-size')];
      // Single "Default Title" variant — skip the panel and add directly
      if (sizeButtons.length === 1 && sizeButtons[0].textContent.trim() === 'Default Title') {
        sizeButtons[0].click();
        return;
      }
      sizes.classList.toggle('open');
    });

    // close sizes when clicking elsewhere
    document.addEventListener('click', (e) => {
      if (!card.contains(e.target)) sizes.classList.remove('open');
    });

    sizes.querySelectorAll('.qs-size').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const variantId = btn.dataset.variantId;
        const size = btn.dataset.size;
        const handle = card.dataset.handle;

        if (!variantId){
          // No variant mapping — fall back to product page
          window.location.href = `/products/${handle}?variant=&size=${encodeURIComponent(size)}`;
          return;
        }

        const origText = btn.textContent;
        btn.disabled = true;
        btn.textContent = '…';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
          });
          if (!res.ok){
            const errBody = await res.json().catch(() => ({}));
            throw new Error(errBody.description || errBody.message || 'add failed');
          }
          // Fully refresh the cart drawer + count
          await refreshCart();
          showToast(`Added ${size} to bag`);
          // Open the drawer
          openCart();
          sizes.classList.remove('open');
          btn.textContent = origText;
          btn.disabled = false;
        } catch (err){
          btn.textContent = origText;
          btn.disabled = false;
          showToast(err.message && err.message.length < 60 ? err.message : 'Could not add, please try again');
        }
      });
    });
  });
}

function showToast(msg){
  let t = document.querySelector('.toast');
  if (!t){ t = document.createElement('div'); t.className = 'toast'; document.body.appendChild(t); }
  t.textContent = msg;
  t.classList.add('show');
  clearTimeout(showToast._t);
  showToast._t = setTimeout(() => t.classList.remove('show'), 2200);
}

/* ---------- hero slideshow ---------- */
function bindSlideshow(scope = document){
  scope.querySelectorAll('[data-slideshow]').forEach(box => {
    if (box.__bound) return; box.__bound = true;
    const slides = [...box.querySelectorAll('[data-slide]')];
    const dots   = [...box.querySelectorAll('[data-slideshow-dot]')];
    const prev   = box.querySelector('[data-slideshow-prev]');
    const next   = box.querySelector('[data-slideshow-next]');
    const autoplayMs = parseInt(box.dataset.autoplay || '0', 10);
    if (slides.length === 0) return;
    let idx = 0;
    let timer = null;

    const go = (n) => {
      idx = (n + slides.length) % slides.length;
      slides.forEach((s,i) => s.classList.toggle('is-active', i === idx));
      dots.forEach((d,i) => d.classList.toggle('is-active', i === idx));
    };
    const tick = () => go(idx + 1);
    const start = () => { if (autoplayMs && slides.length > 1){ stop(); timer = setInterval(tick, autoplayMs); } };
    const stop  = () => { if (timer){ clearInterval(timer); timer = null; } };

    prev?.addEventListener('click', () => { go(idx - 1); start(); });
    next?.addEventListener('click', () => { go(idx + 1); start(); });
    dots.forEach((d,i) => d.addEventListener('click', () => { go(i); start(); }));
    box.addEventListener('mouseenter', stop);
    box.addEventListener('mouseleave', start);

    // swipe support
    let sx = 0, dx = 0;
    box.addEventListener('touchstart', e => { sx = e.touches[0].clientX; dx = 0; stop(); }, { passive: true });
    box.addEventListener('touchmove',  e => { dx = e.touches[0].clientX - sx; }, { passive: true });
    box.addEventListener('touchend',   () => { if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1)); start(); });

    start();
  });
}

/* ---------- mega menu (touch / click toggle) ---------- */
function bindMega(scope = document){
  const items = scope.querySelectorAll('.nav-item.has-mega');
  items.forEach(item => {
    if (item.__bound) return; item.__bound = true;
    const link = item.querySelector('.nav-link');
    // On touch devices, first tap opens, second tap follows the link
    let opened = false;
    link?.addEventListener('click', e => {
      if (window.matchMedia('(hover: none)').matches){
        if (!opened){
          e.preventDefault();
          items.forEach(o => o.classList.remove('open'));
          item.classList.add('open');
          opened = true;
        }
      }
    });
    item.addEventListener('mouseleave', () => { item.classList.remove('open'); opened = false; });
  });
  document.addEventListener('click', e => {
    if (!e.target.closest('.nav-item.has-mega')){
      items.forEach(i => i.classList.remove('open'));
    }
  }, { once: false });
}

/* ---------- carousel arrows ---------- */
function bindCarousel(scope = document){
  scope.querySelectorAll('[data-carousel]').forEach(car => {
    if (car.__bound) return; car.__bound = true;
    const track = car.querySelector('[data-carousel-track]');
    const prev  = car.querySelector('[data-carousel-prev]');
    const next  = car.querySelector('[data-carousel-next]');
    if (!track) return;
    const step = () => {
      const first = track.firstElementChild;
      return first ? first.getBoundingClientRect().width + 16 : 320;
    };
    prev?.addEventListener('click', () => track.scrollBy({ left: -step()*2, behavior: 'smooth' }));
    next?.addEventListener('click', () => track.scrollBy({ left:  step()*2, behavior: 'smooth' }));
  });
}

/* ---------- master init ---------- */
function initAll(scope = document){
  initNav();
  initDrawers(scope);
  bindAddForms(scope);
  bindCartLines();
  bindAccordion(scope);
  bindNewsletter(scope);
  bindWishlist(scope);
  bindCarousel(scope);
  bindMega(scope);
  bindSlideshow(scope);
  bindQuickAdd(scope);
  bindCollectionFilters(scope);
  bindPDP(scope);
  renderRecentlyViewed(scope);
  bindSmileLaunchers(scope);
  bindWishlistButtons(scope);
  renderFavorites(scope);
  initReveal(scope);
  initParallax(scope);
  bindAnchors(scope);
}

initAll();
refreshCart();

/* ---------- Shopify section editor events ---------- */
document.addEventListener('shopify:section:load', e => {
  initAll(e.target);
});
document.addEventListener('shopify:section:select', e => {
  initReveal(e.target);
});
document.addEventListener('shopify:section:reorder', () => initAll());
document.addEventListener('shopify:block:select', e => {
  initReveal(e.target.closest('section') || document);
});
